var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" View the related check-in: "),_c('v-btn',{attrs:{"small":"","color":"primary","to":{ name: 'check-in', params: { id: _vm.context.data }}}},[_vm._v(" Check-In "+_vm._s(_vm.context.data)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }